module.exports = __webpack_public_path__ + "media/images/icon__community@2x-fb5b96a4d7ef8177328d47d009c21b0f.png";